module.exports = __webpack_public_path__ + "img/9788952758675.9151b654.jpg";